import { render, staticRenderFns } from "./mangZhuGrade.vue?vue&type=template&id=dc2ca914&"
import script from "./mangZhuGrade.vue?vue&type=script&lang=js&"
export * from "./mangZhuGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports